import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import logo from "../images/BkvLogo.png";
import headerImage from "../images/headerImage.png";
import arrowDown from "../icons/arrow-down.svg";
import menu from "../icons/menu.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "./widgets/Drawer";
import constants from "src/constants";
import { makeStyles } from "@material-ui/core";
import { GoArrowUp } from "react-icons/go";
import { useDispatch, useSelector } from "src/store";
import ArrowDown from "src/icons/ArrowDown";
import "./style.css";
import { Utils } from "src/utils/Utils";
import { useCookies } from "react-cookie";
import SimpleText from "./SimpleText";

const Header = ({ hasUsage, content }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const hideLink = useMediaQuery("(max-width:1250px)");
  const isPad = useMediaQuery("(max-width:1056px)");
  const [showDrawer, setShowDrawer] = useState(false);
  const [changeColor, setChangeColor] = useState("#09507f");
  const [cookies] = useCookies();

  const state = useSelector((state) => state.bkv);

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: theme.palette.mustard.main,
    whiteSpace: "nowrap",
  }));

  return (
    <Box mb={{ xs: "35%", sm: "35%", md: "15%", lg: "5.5%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: {
            xs: "12% 0% 2% 4%",
            sm: "12% 0% 2% 4%",
            md: "12% 0% 2% 4%",
            lg: "8% 0% 2% 7%",
          },
          position: "relative",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            marginTop: { xs: "12px", md: "3%", lg: "3%" },
            flexDirection: "column",
            width: { xs: "100%", sm: "100%", md: "60%", lg: "50%" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "12px", md: "2vw", lg: "20px" },
              // lineHeight: "4.5vw",
              fontWeight: 600,
              color: theme.palette.secondary.main,
              textTransform: "uppercase",
            }}
            mb="10px"
          >
            <div
              dangerouslySetInnerHTML={{ __html: content?.details?.title }}
            ></div>
          </Typography>

          <Typography
            fontSize={{ xs: "24px", md: "6.5vw", lg: "100px" }}
            sx={{
              lineHeight: { xs: "9vw", sm: "9vw", md: "9vw", lg: "100px" },
              color: theme.palette.primary.main,
              whiteSpace: "normal",
              marginBottom: { xs: "6%", sm: "6%", md: "6%", lg: "0" },
              width: { xs: "60%", sm: "60%", md: "100%" },
            }}
            variant="body2"
          >
            {content?.details?.subtitle}
          </Typography>

          <SimpleText
            style={{
              fontSize: { xs: "15px", md: "3vw", lg: "20px" },
              lineHeight: {
                xs: "5vw",
                sm: "5vw",
                md: "5vw",
                lg: "29px",
              },
              width: { xs: "60%", sm: "60%", md: "70%", lg: "90%" },
              color: "#000",
              marginTop: "9px",
            }}
            text={content?.details?.description}
          />

          {/* <Typography
            fontSize={{ xs: "15px", md: "3vw", lg: "20px" }}
            sx={{
              lineHeight: {
                xs: "5vw",
                sm: "5vw",
                md: "5vw",
                lg: "29px",
              },
              width: { xs: "60%", sm: "60%", md: "70%", lg: "90%" },
              color: "#000",
            }}
            mt="9px"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: content?.details?.description,
              }}
            ></div>
          </Typography> */}

          {!isPad && (
            <Box
              width="148px"
              sx={{
                padding: "2% 0% 0% 0%",
              }}
              onClick={() => {
                if (hasUsage) {
                  document.getElementById("savings-graph").scrollIntoView();
                } else {
                  document.getElementById("bullseye-graph").scrollIntoView();
                }
              }}
            >
              <img
                style={{
                  cursor: "pointer",
                }}
                width="100%"
                src={arrowDown}
              />
            </Box>
          )}
        </Box>

        <Box
          width={{ xs: "40%", sm: "40%", md: "50%", lg: "40%", xl: "40%" }}
          // height={{ xs: "70%", sm: "70%", md: "70%", lg: "auto" }}
          sx={{
            // padding: { lg: "5% 5% 0% 0%" },
            position: "absolute",
            right: { xs: "5%", sm: "5%", md: "5%", lg: "11%" },
            // top: { xs: "10%", sm: "21%", md: "20%", lg: "20%", xl: "18%" },
            bottom: 0,
            zIndex: -1,
          }}
        >
          <img width="100%" src={content?.details?.images?.image1Url2} />
        </Box>
      </Box>
    </Box>
  );
};

export default Header;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  links: {
    color: "#09507F",
    "&: hover": {
      color: "#00b49d",
    },
  },
  arrow: {
    transition: "all .3s ease-in-out",
    position: "absolute",
    top: "20px",
    left: "20px",
    // backgroundImage: "url(../)",
    "&: hover": {
      rotate: "90deg",
      //   filter:
      //     "invert(64%) sepia(48%) saturate(5862%) hue-rotate(137deg) brightness(93%) contrast(101%)",
    },
  },
  arrowdown: {
    transition: "all .3s ease-in-out",
    position: "absolute",
    top: "20px",
    left: "20px",
    // backgroundImage: "url(../)",
    "&: hover": {
      rotate: "90deg",
      fill: "#00b49d",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
